import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { saveReportSettingsSuccess, saveReportSettingsFailed } from '../actions';
import { PaymentReportSettingsTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* saveReportSettings({ payload }) {
  const { formFields, cb } = payload;

  const url = `${API_BASE_URL}/payments/report-settings`;

  const response = yield request({
    method: 'put',
    data: { formFields: formFields || [] },
    url,
  });
  if (response.success) {
    yield put(saveReportSettingsSuccess(response.raw));
    Notify('Payment report columns saved successfully!', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    if (typeof cb === 'function') cb();
  } else {
    yield put(saveReportSettingsFailed(response.message));
    networkErrorHandler(response?.statusCode, `Failed to save report columns: ${response.message}`);
  }
}

export function* savingReportSettings() {
  yield takeLatest(PaymentReportSettingsTypes.SAVING_REPORT_SETTINGS, saveReportSettings);
}
